import { useMemo } from 'react';
import { useAppContext } from '../../../AppContextProvider';
import { useLocalStorage } from '../../../domain/useLocalStorage';
import { READINESS_TRACKING_PAGE_CONST } from './constants';

export const useReadinessTrackingSidebar = () => {
    const { isFiltersSidebarEnabled } = useAppContext();

    const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(READINESS_TRACKING_PAGE_CONST.localStorage.sidebarCollapsedKey, false);

    const layoutPaddingLeft = useMemo(() => {
        if (!isFiltersSidebarEnabled) return '0';

        return sidebarCollapsed ? '35px' : '200px';
    }, [isFiltersSidebarEnabled, sidebarCollapsed]);

    return {
        sidebarCollapsed,
        setSidebarCollapsed,
        layoutPaddingLeft,
        isFiltersSidebarEnabled,
    };
};
